import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const imageUpload = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
        "content-type": "multipart/form-data",
      },
    };
    return await instance.post(
      `banners/image_upload?type=${data.type}`,
      data.form,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const fetchBanners = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/banners`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const postBanner = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(`/banners`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteBanner = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(`/banners/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};
